'use strict';

var loadMoreReports = require('./loadMoreReports');
var pdfPopover = require('../pdf/pdfPopover');

require('../modals/createAdvancedReview');
require('../modals/deleteReview');
require('./expertNotification');
require('../pdf/downloadPdf');
require('./expertBox');

pdfPopover();
loadMoreReports();
